import * as React from 'react';
import { DashboardsContext } from 'apps/boards/src/util/context';
import { useCurrentUser } from 'common/contexts/react/current-user-context';
import { useDashboardSelectorController } from 'common/contexts/react/dashboard-selector-controller-context';
import { BannerLayout } from 'common/report/layout/banner-layout';
import { SubscriptionsPage } from './subscriptions-page';
type Props = {
  context: DashboardsContext;
  onToast(ev: CustomEvent): void;
};
export const ManageDigestsMode = (props: Props) => {
  const currentUser = useCurrentUser();
  const selectorController = useDashboardSelectorController();
  if (!currentUser) return null;
  return <BannerLayout data-sentry-element="BannerLayout" data-sentry-component="ManageDigestsMode" data-sentry-source-file="index.tsx">
      <SubscriptionsPage context={props.context} selectorController={selectorController} data-sentry-element="SubscriptionsPage" data-sentry-source-file="index.tsx" />
    </BannerLayout>;
};